import React from "react";
import { BlogPageSidebar } from "./BlogPageSidebar";

export const BlogPageWrapper = ({ children }) => {
  return (
    <section className="blog-area pt-120 pb-120">
      <div className="container-fluid p-0">
        <div className=" row ">
          <div className="row justify-content-center no-gutters">
            {/* content */}
            <div className="col-12 col-md-10 ">{children}</div>

            {/* sidebar */}
          {/* <div className="col-29">
              <BlogPageSidebar />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};
